import { render } from "./HongsProductCard.vue?vue&type=template&id=2c9e2ad9"
import script from "./HongsProductCard.vue?vue&type=script&lang=js"
export * from "./HongsProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__